import { render, staticRenderFns } from "./WorkloadPorts.vue?vue&type=template&id=1df50e7a&scoped=true&"
import script from "./WorkloadPorts.vue?vue&type=script&lang=js&"
export * from "./WorkloadPorts.vue?vue&type=script&lang=js&"
import style0 from "./WorkloadPorts.vue?vue&type=style&index=0&id=1df50e7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df50e7a",
  null
  
)

export default component.exports